import { Col, PageHeader, Row, Select, Space } from "antd";
import "assets/fonticons/style.css";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import CommissionPlan from "redux/models/commissionPlan";
import {
  selectSelectedClientIds,
  setGlobalRecruiters,
} from "redux/slices/globalSelectorSlice";
import {
  selectAvailableRecruiters,
  selectSelectedRecruiters,
  selectUserId,
} from "redux/slices/userSlice";
import K from "utilities/constants";
import { removeUnderScore } from "utilities/generalUtility";
import LayoutCss from "layout/layout.module.scss";
import { isEmpty } from "lodash";
import { Collapse } from "common/components/collapse/collapse";
import AgGridUtility from "utilities/agGridUtility";
import { ClientSideDataGrid } from "common/components/clientSideDataGrid/clientSideDataGrid";
import { ExportDataButton } from "common/components/ExportDataButton";
import { Columns } from "./columns";
import CommissionStatementExport from "../commissionStatementExport";

export default function CommissionStatements() {
  const history = useHistory();
  const dispatch = useDispatch();

  const userId = useSelector(selectUserId);
  const selectedClientIds = useSelector(selectSelectedClientIds);
  const availableRecruiters = useSelector(selectAvailableRecruiters);
  const selectedRecruiters = useSelector(selectSelectedRecruiters);

  const selectedRecruiterIds = useMemo(
    () => selectedRecruiters.map((i) => i.id),
    [selectedRecruiters],
  );

  const [exportData, setExportData] = useState({
    isModalVisible: false,
  });

  const [pageStates, setPageStates] = useState({
    listing: [],
    activeKey: [],
  });

  const onChange = (key) => {
    setPageStates((prev) => ({
      ...prev,
      activeKey: key,
    }));
  };
  const onRecruiterChange = (value) => {
    if (value.length === 0) {
      setPageStates({ listing: [], activeKey: [] });
    }

    dispatch(setGlobalRecruiters(value));
  };

  const rowClickedHandler = (params) => {
    history.push(`/billings/commission-statement/detail/${params.data.id}`);
  };

  const updateRowData = (commissionStatement) => {
    return commissionStatement.map((item) => ({
      ...item,
      status: removeUnderScore(item.status),
      amount: item.status === "NOT_ELIGIBLE" ? 0 : item.amount,
    }));
  };

  useEffect(() => {
    (async () => {
      try {
        if (selectedRecruiterIds.length === 0) return;
        const res =
          await CommissionPlan.getCommissionStatements(selectedRecruiterIds);

        setPageStates((prev) => ({
          ...prev,
          listing: res,
          activeKey: [...Array(res.length)].map((_, i) => i),
        }));
      } catch (err) {
        console.error(err);
      }
    })();
  }, [selectedRecruiterIds]);

  return (
    <>
      <PageHeader
        className={`${LayoutCss.appPageHeader} ${LayoutCss.pageHeader}`}
        ghost={false}
        title="Commission Statement"
        extra={
          <>
            <ExportDataButton
              onClick={() => setExportData({ isModalVisible: true })}
            />
            <Select
              showArrow
              optionFilterProp="label"
              mode="multiple"
              showSearch
              allowClear
              maxTagCount={1}
              maxTagPlaceholder={(omittedValues) => {
                return (
                  <span className="custom-max-tag-count">
                    +{omittedValues.length}
                  </span>
                );
              }}
              placeholder="Select Recruiters"
              className="commision-select"
              value={selectedRecruiterIds}
              options={availableRecruiters.map((item) => ({
                value: item.id,
                label: item.name,
                disabled:
                  selectedRecruiters.length >= 10 &&
                  !selectedRecruiters.includes(item.id),
              }))}
              onChange={onRecruiterChange}
            />
          </>
        }
      />
      {isEmpty(selectedRecruiters) ? (
        <Row justify="center" align="middle" style={{ marginTop: "100px" }}>
          <Col>
            <div style={{ fontSize: "20px", textAlign: "center" }}>
              Please select recruiters to view commission statements
            </div>
          </Col>
        </Row>
      ) : (
        <Space direction="vertical" style={{ width: "100%" }}>
          {pageStates.listing.map((item, i) => (
            <Collapse expandIconPosition="end" onChange={onChange} key={i}>
              <Collapse.Panel header={item.name} key={i}>
                <ClientSideDataGrid
                  userId={userId}
                  configKey={
                    K.AgGridTable.Keys.CommissionStatementVisibleColumn
                  }
                  defaultColumnConfig={Columns}
                  height={370}
                  rowData={updateRowData(item.commissionStatements)}
                  onRowClicked={rowClickedHandler}
                  scroll={{ x: 400 }}
                  paginationPageSize={6}
                  rowStyle={{ cursor: "pointer" }}
                  getContextMenuItems={() => AgGridUtility.menuItemsWithExport}
                />
              </Collapse.Panel>
            </Collapse>
          ))}
        </Space>
      )}
      <CommissionStatementExport
        exportData={exportData}
        setExportData={setExportData}
        recruiterIds={selectedRecruiterIds}
        clientIds={selectedClientIds}
      />
    </>
  );
}
